var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('PreLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }